import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'enumToValue'
})
export class EnumToValuePipe implements PipeTransform {

  transform(value: any, enumType: any): string {
    console.log("value",value,"enumType",enumType)
    return enumType[value];
  }

}
